<template>
	<div class="myCont">
		<div class="main">
			<div class="infosearch">
				<el-input v-model="keyName" placeholder="输入员工姓名/手机号查询" @keyup.native='specialCharacter' style="width: 284px;margin-right: 10px"></el-input>
				<el-button class="searchBtn" @click="search(1)" v-loading.fullscreen.lock="fullscreenLoading"></el-button>
				<el-button class="addMems" @click="addMemes">添加员工</el-button>
			</div>
			<el-table v-if="tableData.length > 0" :data="tableData" height='601' ref="multipleTable" :cell-class-name="tableRowClassName" @row-dblclick="linkTo" class="myMemTable" style="width: 100%" :header-cell-style="{background:'#EFF1F5'}">
				<el-table-column align="center" type="index" label="序号" width="80"></el-table-column>
				<el-table-column align="center" prop="staffId" label="员工编号" width="180"></el-table-column>
				<el-table-column align="center" prop="staffName" label="员工姓名" width="218"></el-table-column>
				<el-table-column align="center" prop="staffPhone" label="员工手机号"></el-table-column>
				<el-table-column align="center" prop="postId" label="岗位">
					<template slot-scope="scope">
						{{scope.row.postId | filterPostId(infolist.postIdData) | filterRow}}
					</template>
				</el-table-column>
				<el-table-column align="center" prop="hiredate" label="入职时间">
					<template slot-scope="scope">
						{{scope.row.hiredate | formatDatenoH | filterRow}}
					</template>
				</el-table-column>
				<el-table-column align="center" prop="appCreateTime" label="APP注册时间" >
					<template slot-scope="scope">
						{{scope.row.appCreateTime | formatDateLiness | filterRow}}
					</template>
				</el-table-column>
				<el-table-column align="center" prop="status" label="状态">
					<template slot-scope="scope">
						{{scope.row.status | filterStatus | filterRow}}
					</template>
				</el-table-column>
				<el-table-column align="center" label="操作" width="180" class-name="operation">
					<template slot-scope="scope">
						<el-button size="mini" type="danger" @click.stop="editTo(scope.row.staffId)">修改</el-button>
						<el-button size="mini" class="deleteBtn" @click.stop="deletes(scope.row.staffId)">删除</el-button>
					</template>
				</el-table-column>
			</el-table>
			<template v-else>
				<div class="emptys">查不到员工信息！再核对一下试试</div>
			</template>
			<el-pagination v-if="total" @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="currentPage" :page-sizes="[10, 20, 30, 40]" :page-size="pageSize" background layout="total, sizes, prev, pager, next, jumper" :total="total" style="margin-top: 20px;text-align:right"></el-pagination>
		</div>
	</div>
</template>
<script type="text/javascript">
import { searchStaff, updateStaff } from "@/api";
import infolist from '@/assets/js/info'
import vFilter from "@/assets/js/filter";
import Vue from "vue";
for (let key in vFilter) {
  Vue.filter(key, vFilter[key]);
}

export default {
  data() {
    return {
      keyName: "",
      tableData: [],
      pageSize: 10,
      currentPage: 1,
      total: 0,
      fullscreenLoading: false,
      infolist:infolist,
    };
  },
  created() {
    this.search();
    if(this.$store.state.aliveStatus){
      this.currentPage =  this.$store.state.alivePage;
      this.search();
      this.$store.commit("setAliveStatus", false);//取消列表页状态
      this.$store.commit("setAlivePage", 1);//取消页码状态
    }
  },
  methods: {
    tableRowClassName({ row, column, rowIndex, columnIndex }) {
      //把每一行的索引放进row
      if (rowIndex%2 == 1) {
        return 'highLight';
      }
      return '';
    },
    specialCharacter() {
      this.keyName = this.keyName.replace(
        /[`~!@#$%^&*()_\-+=<>?:"{}|,.\/;'\\[\]·~！@#￥%……&*（）——\-+={}|《》？：“”【】、；‘’，。、]/im,
        ""
      );
    },
    handleSizeChange(val) {
      this.pageSize = val;
      this.search();
    },
    handleCurrentChange(val) {
      this.currentPage = val;
      this.search();
    },
    async search(val) {
      this.fullscreenLoading = true;
      if (val == 1) {
        this.currentPage = 1;
      }
      let res = await searchStaff({
        keyword: this.keyName,
        pageSize: this.pageSize,
        pageNumber: this.currentPage
      });
      this.fullscreenLoading = false;
      this.total = res.data.total;
      this.tableData = res.data.rows;
    },
    addMemes() {
      // 添加员工
      this.$router.push("/basicDataCenter/addStaff");
    },
    linkTo(row) {
      // 跳转员工详情
      this.$router.push("/basicDataCenter/staffView=" + row.staffId);
      this.$store.commit('setAlivePage',this.currentPage)
    },
    deletes(staffId) {
      // 删除
      this.$alert(
        "<h2>确认要删除该员工的信息吗？</h2><p>确定删除后不可恢复。</p>",
        "",
        {
          dangerouslyUseHTMLString: true,
          customClass: "memBox",
          showCancelButton: true,
          confirmButtonText: "确认删除",
          cancelButtonText: "暂时不删",
          cancelButtonClass: "darkBtn",
          confirmButtonClass: "redBtn",
          closeOnClickModal: true
        }
      )
        .then(({ value }) => {
          updateStaff({
            staffId: staffId,
            deleteFlag: '1',
            operateFlag:'2'
          }).then(res => {
            this.search();
            this.$message({
              type: res.code == 1 ? "success" : "error",
              message: res.msg
            });
          });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "暂时不删"
          });
        });
    },
    editTo(staffid) {
      // 修改员工
      this.$router.push("/basicDataCenter/staffid=" + staffid);
      this.$store.commit('setAlivePage',this.currentPage)
    }
  }
};
</script>
<style lang="less" scoped>
.main {
  padding: 25px 0;
  .infosearch {
    .el-input__inner {
      border-radius: 20px;
    }
    .searchBtn {
      width: 47px;
      height: 38px;
      background: #f83b56 url(../../assets/images/store/btn_datalist_search.png)
        no-repeat center;
    }
    .addMems {
      color: #fff;
      font-weight: bold;
      text-indent: 20px;
      background: #3b404f url(../../assets/images/store/btn_datalist_add.png)
        no-repeat 15px center;
    }
  }
  .myMemTable {
    margin-top: 25px;
    border: 1px solid #D5D9E3;
    .el-button--mini {
      padding: 8px;
      font-weight: bold;
    }
    .el-button + .el-button {
      margin-left: 0;
    }
    .deleteBtn {
      border: 1px solid #f96479;
      color: #f83b56;
      font-weight: bold;
    }
  }
  .defaults,
  .emptys {
    height: 600px;
    background: url(../../assets/images/store/img_vip_inquire.png) no-repeat
      center;
    text-align: center;
    font-size: 15px;
    color: #666;
    padding-top: 450px;
  }
  .emptys {
    background: url(../../assets/images/store/img_vip_none.png) no-repeat center;
  }
}
</style>
<style lang="less">
.myMemTable {
  .operation {
    .cell {
      padding: 0;
    }
  }
  .el-table__header{
    background:rgb(239, 241, 245);
  }
  .highLight {
    background: #EFF1F5;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/basicDataCenter/employeeBasicInfo.vue